import { trackCustomEvent } from '@/hooks/client/use-analytics-engine'
import { EventType } from '@/lib/analytics/events'
import { linkDestination } from '@/lib/analytics/link-destination'

export const hubSection = (element: Element): string => {
  const section = element.closest('section[aria-labelledby], section[id]')
  return section?.getAttribute('aria-labelledby')?.split(' ')[0] ?? section?.id ?? 'article'
}

export const trackHubLink = (event: MouseEvent) => {
  if (event.type === 'auxclick' && event.button !== 1) {
    return
  }
  const link = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('main a[href]') : null
  // Existing affiliate/directory tracking remains the source of truth for
  // those links. Chat citations have their own attributed click events.
  if (!link || link.closest('[data-advisor-placement]') || link.hasAttribute('data-track')) {
    return
  }
  const destination = linkDestination(link.href)
  if (destination) {
    const url = new URL(link.href)
    trackCustomEvent('hub_link_clicked', EventType.Click, {
      ...destination,
      section: hubSection(link),
      // Anchors on this page are fixed section ids; query parameters and link
      // labels are omitted so search/contact content cannot enter the event.
      ...(url.origin === window.location.origin && url.pathname === window.location.pathname
        ? { anchor: url.hash }
        : {}),
    })
  }
}
